import JSSHA from 'jssha'

export default async function generateSHA384Hash(input) {
  const shaObj = new JSSHA('SHA-384', 'TEXT', {encoding: 'UTF8'})
  shaObj.update(input)
  return shaObj.getHash('HEX')
}
